<template id="switch-button">
  <div class="switch-button-control">
    <div
      class="switch-button"
      :class="{ enabled: isEnabled }"
      @click="toggle"
      :style="{'--color': color}"
    >
      <div class="button"></div>
    </div>
    <div class="switch-button-label">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "switch-button",
  model: {
    prop: "isEnabled",
    event: "toggle",
  },
  props: {
    isEnabled: Boolean,
    color: {
      type: String,
      required: false,
      default: "#4D4D4D",
    },
    meuid: null,
    modulo: null,
    funcao: null,
  },
  methods: {
    toggle: function () {
      
      this.$emit("toggle", !this.isEnabled);

      this.chamadaApi();
    },
    async chamadaApi() {
      try {
        if (this.modulo == "departamento" && this.funcao == "exibirPublico") {
          //console.log('clicou id: '+this.meuid +' valor: '+ !this.isEnabled +' Modulo: '+ this.modulo +' função: '+this.funcao);
          let valor;
          if (!this.isEnabled == true) {
            valor = 1;
          } else {
            valor = 0;
          }

          let s = await this.$secretariaEditPublico(this.meuid, valor);
        }
        if (this.modulo == "departamento" && this.funcao == "exibirStatus") {
          // console.log('clicou id: '+this.meuid +' valor: '+ !this.isEnabled +' Modulo: '+ this.modulo +' função: '+this.funcao);
          let valor;
          if (!this.isEnabled == true) {
            valor = 1;
          } else {
            valor = 0;
          }
          
          if(valor==0){
            let sp = await this.$secretariaEditPublico(this.meuid, valor);
          }
          if(valor==1){
            let r =1;
            let sp = await this.$secretariaEditPublico(this.meuid, r);
          }

          let s = await this.$secretariaEditStatus(this.meuid, valor);
        }
        if (this.modulo == "assunto" && this.funcao == "exibirStatus") {
          //console.log('clicou id: '+this.meuid +' valor: '+ !this.isEnabled +' Modulo: '+ this.modulo +' função: '+this.funcao);
          let valor;
          if (!this.isEnabled == true) {
            valor = 1;
          } else {
            valor = 0;
          }

          let s = await this.$assuntoEditStatus(this.meuid, valor);
        }

        if (this.modulo == "cidadao" && this.funcao == "exibirStatus") {
          //console.log('clicou id: '+this.meuid +' valor: '+ !this.isEnabled +' Modulo: '+ this.modulo +' função: '+this.funcao);
          let valor;
          if (!this.isEnabled == true) {
            valor = 1;
          } else {
            valor = 0;
          }

          let m = await this.$me();
          let c = await this.$cidadaoEditStatus(this.meuid, valor, m.id);
        }
        //exibirStatus
        if (this.modulo == "usuario" && this.funcao == "exibirStatus") {
          //console.log('clicou id: '+this.meuid +' valor: '+ !this.isEnabled +' Modulo: '+ this.modulo +' função: '+this.funcao);
          let valor;
          if (!this.isEnabled == true) {
            valor = 1;
          } else {
            valor = 0;
          }

          let s = await this.$usuarioEditarStatus(this.meuid, valor);
        }
        if (this.modulo == "usuario" && this.funcao == "exibirCadastro") {
           let valor;
            if (!this.isEnabled == true) {
              valor = 1;
            } else {
              valor = 0;
            }
        }
        if (this.modulo == "usuario" && this.funcao == "exibirEditar") {
           let valor;
            if (!this.isEnabled == true) {
              valor = 1;
            } else {
              valor = 0;
            }
        }
        if (this.modulo == "permissao" && this.funcao == "exibirStatus") {
           let valor;
            if (!this.isEnabled == true) {
              valor = 1;
            } else {
              valor = 0;
            }
            
            let data = await this.$permissaoMudarStatus(valor,this.meuid);
        }
      } catch (error) {}
    },
  },
};
</script>
<style >
.switch-button {
  margin: 10px 0;
}
.bottom-message {
  margin-top: 20px;
  font-size: 125%;
}
.switch-button-control {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.switch-button-control .switch-button {
  height: 1.6em;
  width: calc(1.6em * 2);
  border: 2px solid var(--color);
  box-shadow: inset 0px 0px 2px 0px rgba(0, 0, 0, 0.33);
  border-radius: 1.6em;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}
.switch-button-control .switch-button .button {
  height: calc(1.6em - (2 * 2px));
  width: calc(1.6em - (2 * 2px));
  border: 2px solid var(--color);
  border-radius: calc(1.6em - (2 * 2px));
  background: var(--color);
  transition: all 0.3s ease-in-out;
}
.switch-button-control .switch-button.enabled {
  background-color: var(--color);
  box-shadow: none;
}
.switch-button-control .switch-button.enabled .button {
  background: white;
  transform: translateX(calc(calc(1.6em - (2 * 2px)) + (2 * 2px)));
}
.switch-button-control .switch-button-label {
  margin-left: 10px;
}
</style>
